<template>
  <div>
    <div class="container mt-4" v-if="error">
      <div class="alert alert-danger">{{ error | translate }}</div>
    </div>
    <form @submit.prevent="emitSave" id="SubbrancheAddEditDialog">
      <h4 class="mb-4">{{ 'ADD' | translate }}</h4>

      <div class="form-group" id="SubbrancheAddEditDialog-formGroup-naam">
        <label>{{ 'Code' | translate }} <span class="asterisk">*</span></label>
        <input type="text"
               pattern="\d{1,5}"
               class="form-control form-control-sm"
               v-model="subbranche.code"
               @input="onCodeInput"
               :disabled="Boolean(edited)"
               maxlength="5"
               required
               id="SubbrancheAddEditDialog-formGroup-naam-input">
      </div>

      <div class="form-group" id="SubbrancheAddEditDialog-formGroup-BrancheTable">
      <label>{{ "Branche" | translate }} <span class="asterisk">*</span></label>
      <select
        class="form-control form-control-sm"
        v-model="subbranche.branche"
        required
        id="SubbrancheAddEditDialog-formGroup-BrancheTable-select"
      >
        <option value="" :id="'SubbrancheAddEditDialog-select-option-BrancheTable-'+ ' '"></option>
        <template v-for="brancherecord in branche">
          <option :key="brancherecord.name" :value="brancherecord.name" :id="'SubbrancheAddEditDialog-select-option-'+brancherecord.name">
            {{brancherecord.description}}
          </option>
        </template>
      </select>
    </div>

      <div class="form-group" id="SubbrancheAddEditDialog-formGroup-Omschrijving">
        <label>{{ 'SUBBRANCHE_DESCRIPTION' | translate }} <span class="asterisk">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="subbranche.description"
               maxlength="50"
               required
               id="SubbrancheAddEditDialog-formGroup-Omschrijving-input">
      </div>

      <div class="form-group" id="SubbrancheAddEditDialog-formGroup-Enabled">
        <label>{{ 'Enabled' | translate }}</label>
        <input type="checkbox"
               class="form-control form-control-sm"
               v-model="subbranche.enabled"
               id="SubbrancheAddEditDialog-formGroup-Enabled-input">
      </div>

      <div class="mt-4 text-right" id="SubbrancheAddEditDialog-formGroup-buttons">

        <button class="btn btn-link" type="button"
                @click="emitClose"
                id="SubbrancheAddEditDialog-closeButton"
        >{{ 'CLOSE' | translate }}</button>

        <button class="btn btn-primary"
                type="submit"
                :disabled="!isFormValid"
                id="SubbrancheAddEditDialog-addButton"
        >{{ 'ADD' | translate }}</button>

      </div>
    </form>
  </div>
</template>

    <script>
    import GeneralConfigService from '../../../service/GeneralConfigService';

    export default {
      props: ['edited', 'branche', 'errorMessage'],
      data() {
        return {
          subbranche: {},
          error: ''
        }
      },
      computed: {
        isFormValid() {
          return /^\d{1,5}$/.test(this.subbranche.code) && this.subbranche.description && this.subbranche.branche;
        }
      },
      methods: {
        onCodeInput(e) {
          this.subbranche.code = e.target.value.replace(/\D/g, '').slice(0, 5);
        },
        emitSave() {
          this.$emit(this.edited ? 'update' : 'save', this.subbranche);
          if (this.subbranche.enabled) {
            GeneralConfigService.addOrUpdateEnabledSubbranche(this.subbranche);
          } else {
            GeneralConfigService.removeEnabledSubbranche(this.subbranche);
          }
          this.error = ''
          this.$emit('clearErrorMessage', this.error);
        },
        emitClose() {
          this.error = '';
          this.$emit('close');
          this.clearSubbranche();
        },
        dismissAlertError: function () {
          this.error = '';
        },
        clearSubbranche() {
          this.subbranche = {};
        }
      },
      watch: {
        edited(newVal, oldVal) {
          this.subbranche = {...newVal};
        },
        errorMessage(val) {
          this.error = val
        }
      }
    }
    </script>

    <style lang="scss" scoped>
    .asterisk {
      color: $danger;
    }

    >>> .vdp-datepicker__calendar {
      bottom: 30px;
    }
    </style>



// WEBPACK FOOTER //
// src/components/admin/Subbranche/SubbrancheAddEditDialog.vue